import { render, staticRenderFns } from "./mealplan.vue?vue&type=template&id=0549fa28&scoped=true"
import script from "./mealplan.vue?vue&type=script&lang=js"
export * from "./mealplan.vue?vue&type=script&lang=js"
import style0 from "./mealplan.vue?vue&type=style&index=0&id=0549fa28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0549fa28",
  null
  
)

export default component.exports